// form
import { useI18n } from 'iomart-hooks';
import { useFormContext, Controller, type RegisterOptions } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  noT?: boolean;
  /** Вызывается после onChange (для синхронизации связанных полей) */
  onAfterChange?: (value: string | number) => void;
  rules?: RegisterOptions;
};

export default function RHFTextField({ name, label, noT, helperText, onAfterChange, rules, ...other }: Props) {
  const { control } = useFormContext();
  const { t } = useI18n(false);
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const { ref, ...restField } = field;
        return (
          <TextField
            {...restField}
            inputRef={ref}
            onChange={(e) => {
              field.onChange(e);
              onAfterChange?.(e.target.value);
            }}
            label={noT ? label : t(label)}
            sx={{
              '& .MuiOutlinedInput-input': {
                font: 'menu'
              }
            }}
            fullWidth
            value={field.value == null || (typeof field.value === 'number' && field.value === 0) ? '' : field.value}
            error={!!error}
            helperText={error ? error?.message : helperText}
            size="small"
            InputLabelProps={{ shrink: true }}
            {...other}
          />
        );
      }}
    />
  );
}
